<template>
    <v-dialog 
        v-model="showDialog"         
        :max-width="maxDialogWidth"
        :scrollable="scrollable"
        persistent
        :retain-focus="false"
    >
        <v-card :max-height="maxCardHeight" :color="dialogBackgroundColor">
<!-- HEADER -->
            <v-toolbar :color="headlineBackgroundColor" :flat="flatHeader">
                <v-toolbar-title 
                    :class="(headlineTextColor || 'dialogStandardHeadlineText') + '--text'"
                    :alvqa="alvqa + '-title'"
                >{{ $alvPlugin.isLangConst(headline) ? $t(headline) : headline }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="mt-4">
                    <slot name="headerActions"></slot>
                    <BaseIcon
                        icon="close"
                        color="iconCancel"
                        @click="close"
                        :alvqa="alvqa + '-icon-close'"
                        style="order: 99"
                    ></BaseIcon>
                </v-toolbar-items>
            </v-toolbar>  
<!-- CONTENT -->
                <v-card-text class="pt-3">
                    <slot name="dialogText"></slot>
                </v-card-text>                
                <v-card-actions class="pt-0 pr-6 pl-6">
                    <slot name="dialogActions"></slot>
                </v-card-actions>

                <!-- Special slot for v-card-actions with validation (e.g. FileImportDialog) -->
                <slot name="actionsWithValidation"></slot>
        </v-card>
    </v-dialog>
</template>

<script>
import VDialog from 'vuetify/es5/components/VDialog'
import BaseIcon from '../_buttons/BaseIcon'

export default {
    name: "BaseDialog",
    components: {
        BaseIcon
    },
    props: {
        showDialog: {
            type: Boolean,
            required: true,
            default: false
        },
        maxCardHeight: {
            type: String,
            default: "300"
        },
        maxDialogWidth: {
            type: String,
            default: "500"
        },
        headline: {
            type: String,
            required: true
        },
        close: {
            type: Function,
            required: true
        },
        scrollable: {
            type: Boolean,
            default: true
        },
        headlineBackgroundColor: {
            type: String,
            default: "dialogStandardHeaderBackground",
        },
        headlineTextColor: {
            type: String,
            default: 'dialogStandardHeadlineText'
        },
        flatHeader: {
            type: Boolean,
            default: false
        },
        dialogBackgroundColor: {
            type: String,
            default: "dialogStandardBackground"
        },
        alvqa: {
            type: String,
            default: ''
        }
    }
}
</script>

<style>
.v-card__subtitle, .v-card__text {
    color: var(--v-dialogStandardText-base) !important;
}
.v-dialog .v-card__subtitle,
.v-dialog .v-card__text {
    font-size: 1rem !important;
}
</style>
